export const SUPPORT_PHONE = '+91-8796447298';
export const SUPPORT_PHONE_TEL = '+918796447298';
export const WHATSAPP_NUMBER = '918796447298';
